import GridAccordion, {SELECTORS as ACCORDION_SELECTORS} from "../../../Components/Accordion/GridAccordion";

import '../../../Components/Accordion/_index.scss';
$(ACCORDION_SELECTORS.root).each((i, accordion) => {
    new GridAccordion(accordion);
});